const fetchBillsInProgress = false
const requestArrayStatus = []
const billsBuffer = []
const transformedItens = []
const productList = []
const reportReloadTimeout = null
const showSplash = true
const fetchBillsFailures = []

export default {
  fetchBillsInProgress,
  requestArrayStatus,
  billsBuffer,
  transformedItens,
  productList,
  reportReloadTimeout,
  showSplash,
  fetchBillsFailures,
}
